export const registerArray = [
  'getUserInfo',
  'getScheInfo',
  'scheEditSuccess', // 创建编辑任务完成
  'meetingModule', // 会议室入口添加日程
  'getLocation', // 获取当前经纬度跟地址
  'openSysBrowser', // 移动端下载跳转浏览器  warn
  'viewSchedule', //通讯录查看对方日程
  'openPdf', // 打开pdf
  'userInformation', // 动态拿到用户信息
  'saveToGallery', // 保存图片到本地 warn
  'sendPluginResult', // 开启相册权限
  'copy', // 复制 warn
  'logout', // 重新登陆 warn
  'saveScreenshot', // 年度报告图片下载
  'statusBarColor', // 设置状态栏颜色
  'judgeSystem', // 判断系统
  'statusBarHeight'
]

// 0:免呼叫，1:失败，2:未确认，3:已确认
export const EVENT_STATUS_LIST = [
  { text: '免呼叫', color: '#cccccc', id: '0' },
  { text: '失败', color: '#f54a7d', id: '1' },
  { text: '未确认', color: '#ff8d17', id: '2' },
  { text: '已确认', color: '#2cc400', id: '3' }
]

// 发送渠道 id 与接口参数字段映射
export const CHANNEL_PARAM_FIELD = {
  1: 'isWeChat',
  2: 'isMessage',
  3: 'isHoc'
}